import { documentReady } from "../Utility/utils";
import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

documentReady((event) => {
  const body = document.querySelector('body');
  const siteIntro = body.classList.contains("home") && !sessionStorage.getItem("site_visited");
  const featIntro = document.querySelector(".featured_intro");
  // Check if site intro or featured story VO intro modals are open, and if not, start watching for animated elements
  if(!siteIntro && !featIntro) {
    addAnimScrollTrigger();
  }
  // Else, check featured-post-intro.js and site-intro.js for initializing after modal closes.
});


export function addAnimScrollTrigger() {
  // Trigger animation active class
  const scrollTriggerEls = document.querySelectorAll('.data-scroll, .data-scroll-wrapper, [loading="lazy"]');

  const isOnScreen = (element) => {
    const scrollPos = window.pageYOffset | document.body.scrollTop;
    const elemTop = element.getBoundingClientRect().top + scrollPos;
    const elemBottom = elemTop + element.offsetHeight;
    const windowBottom = scrollPos + window.innerHeight;

    return (elemTop >= scrollPos && elemTop < windowBottom) || (elemBottom < windowBottom && elemBottom > scrollPos);
  }

  if(scrollTriggerEls){
    scrollTriggerEls.forEach(elem => {
      if(!elem.classList.contains('no-animation')){
        ScrollTrigger.create({
          trigger: elem,
          onEnter: function(self){
            // onEnter will often fire on page load, even if the element isn't actually on screen.
            if(isOnScreen(elem)){
              if(elem.getAttribute('loading') == 'lazy'){
                ScrollTrigger.refresh();
              }

              addAnimationClass(elem);
            }
          },
          onEnterBack: function(self){
            addAnimationClass(elem);
          }
        });
      }
    });
  }
}

export function addAnimationClass(elem) {
  if(elem.classList.contains('data-scroll')){
    elem.classList.add('is-inview');
  }
  if(elem.classList.contains('data-scroll-wrapper')){
    elem.classList.add('in-viewport');
  }
}
